var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.06467 5.91895H0.303467V17.9132H4.06467V5.91895Z",
    fill: "#046242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2389 5.65908C14.1003 5.64174 13.9529 5.63308 13.8056 5.62441C11.6997 5.53775 10.5124 6.7857 10.0964 7.32302C9.98374 7.47034 9.93174 7.55701 9.93174 7.55701V5.95373H6.33521V17.948H9.93174H10.0964C10.0964 16.726 10.0964 15.5127 10.0964 14.2908C10.0964 13.6321 10.0964 12.9735 10.0964 12.3148C10.0964 11.5002 10.0357 10.6336 10.4431 9.88826C10.7897 9.26428 11.4137 8.95229 12.1157 8.95229C14.1956 8.95229 14.2389 10.8329 14.2389 11.0062C14.2389 11.0149 14.2389 11.0235 14.2389 11.0235V18H18.0001V10.1742C18.0001 7.49634 16.6395 5.91907 14.2389 5.65908Z",
    fill: "#046242"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.18392 4.36784C3.39006 4.36784 4.36784 3.39007 4.36784 2.18392C4.36784 0.977775 3.39006 0 2.18392 0C0.97777 0 0 0.977775 0 2.18392C0 3.39007 0.97777 4.36784 2.18392 4.36784Z",
    fill: "#046242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.4f9ceb58d475b2e7f7ca6a181c9d8df1.svg";
export { ForwardRef as ReactComponent };